import { colors } from '../../../config/theme'

export default {
  generalError: {
    height: 20,
    textAlign: 'center',
    textTransform: 'capitalize',
    color: colors.error
  },
  field: {
    minWidth: '330px'
  }
}


// WEBPACK FOOTER //
// ./src/containers/MarketingOptIn/MarketingOptInForm/style.js